import { Outlet } from "react-router-dom";
import { PageHeader } from "../../components/PageHeader";
import styles from "./DataMarts.module.css";

function DataMartsLayout() {
  return (
    <div className={styles.wrapper}>
      <PageHeader
        title="Data Marts"
        subtitle="Browse analytics data marts provided by the Data Team"
      />
      <Outlet />
    </div>
  );
}

export default DataMartsLayout;
